import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class TagService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async getReleaseTags(projectUUID) {

        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getReleaseTagsUnreleased(projectUUID) {

        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag/Unreleased" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getReleaseTag(tagUUID) {

        const queryString = "?tagUUID=" + encodeURIComponent(tagUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag/Detail" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }


    async releaseTag(tagUUID) {

        const queryString = "?tagUUID=" + encodeURIComponent(tagUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag/Release" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                },
                method: "POST"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }


    async getTasksInTag(tagUUID) {

        const queryString = "?tagUUID=" + encodeURIComponent(tagUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async addTasksToReleaseTag(tagUUID, taskUUIDs) {

        let sprintUpdateObject = {
            Tasks: taskUUIDs
        };

        const queryString = "?tagUUID=" + encodeURIComponent(tagUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify(sprintUpdateObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async removeTasksFromReleaseTag(tagUUID, taskUUIDs) {

        let sprintUpdateObject = {
            Tasks: taskUUIDs
        };

        const queryString = "?tagUUID=" + encodeURIComponent(tagUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "DELETE",
                body: JSON.stringify(sprintUpdateObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async createReleaseTag(projectUUID, releaseTagName, releaseTagDescription) {

        let releaseTypeObject = {
            releaseName: releaseTagName,
            releaseDescription: releaseTagDescription
        };

        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Tag" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify(releaseTypeObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/tagService.js